<section class="content-section">
  <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 32px; border-bottom: 2px solid rgba(0,0,0,0.06); padding-bottom: 0;">
    <button 
      type="button"
      class="btn"
      [class.btn-primary]="activeSection === 'profil'"
      [class.btn-secondary]="activeSection !== 'profil'"
      (click)="switchSection('profil')"
      style="border-radius: 10px 10px 0 0; margin-bottom: -2px; padding: 12px 20px; border-bottom: 3px solid transparent;"
      [style.border-bottom-color]="activeSection === 'profil' ? 'var(--primary-color)' : 'transparent'">
      👤 Informations personnelles
    </button>
    <button 
      type="button"
      class="btn"
      [class.btn-primary]="activeSection === 'password'"
      [class.btn-secondary]="activeSection !== 'password'"
      (click)="switchSection('password')"
      style="border-radius: 10px 10px 0 0; margin-bottom: -2px; padding: 12px 20px; border-bottom: 3px solid transparent;"
      [style.border-bottom-color]="activeSection === 'password' ? 'var(--primary-color)' : 'transparent'">
      🔒 Mot de passe
    </button>
  </div>

  @if (activeSection === 'profil') {
    <form class="form-container" [formGroup]="profilForm" (ngSubmit)="sauvegarderProfil()">
      <div class="form-section">
        <div style="text-align: center; margin-bottom: 24px;">
          <div style="position: relative; display: inline-block;">
            <div style="width: 120px; height: 120px; border-radius: 50%; background: var(--primary-light); display: flex; align-items: center; justify-content: center; font-size: 48px; margin: 0 auto; overflow: hidden;">
              @if (photoUrl !== 'assets/images/avatar-default.svg') {
                <img [src]="photoUrl" alt="Photo de profil" style="width: 100%; height: 100%; object-fit: cover;">
              } @else {
                👤
              }
            </div>
            <label for="photoInput" class="btn-icon" style="position: absolute; bottom: 0; right: 0; background: var(--primary-color); color: white; cursor: pointer;">
              📷
              <input 
                type="file" 
                id="photoInput" 
                accept="image/*"
                (change)="onFileSelect($event)"
                style="display: none;">
            </label>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section-title">Informations personnelles</h3>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Nom *</label>
            <input type="text" class="form-input" formControlName="nom" placeholder="Votre nom">
          </div>
          <div class="form-group">
            <label class="form-label">Prénom(s) *</label>
            <input type="text" class="form-input" formControlName="prenom" placeholder="Vos prénoms">
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section-title">Informations de contact</h3>
        <div class="form-group">
          <label class="form-label">Adresse e-mail *</label>
          <input type="email" class="form-input" formControlName="email" placeholder="votre.email@exemple.com">
        </div>
        <div class="form-group">
          <label class="form-label">Téléphone mobile</label>
          <input type="tel" class="form-input" formControlName="contact" placeholder="+225 01 00 00 00 00">
        </div>
        <div class="form-group">
          <label class="form-label">Adresse</label>
          <input type="text" class="form-input" formControlName="adresse" placeholder="Votre adresse">
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="profilForm.invalid || chargement">
          @if (!chargement) {
            Enregistrer les modifications
          } @else {
            ⏳ Sauvegarde...
          }
        </button>
      </div>
    </form>
  }

  @if (activeSection === 'password') {
    <form class="form-container" [formGroup]="motPasseForm" (ngSubmit)="changerMotPasse()">
      <div class="form-section">
        <h3 class="form-section-title">Modifier le mot de passe</h3>
        <div class="form-group">
          <label class="form-label">Mot de passe actuel *</label>
          <div class="password-input-wrapper">
            <input
              [type]="masquerAncienMotPasse ? 'password' : 'text'"
              class="form-input password-input"
              formControlName="ancienMotPasse"
              placeholder="••••••••">
            <button
              type="button"
              class="password-toggle-btn"
              (click)="masquerAncienMotPasse = !masquerAncienMotPasse"
              [attr.aria-label]="masquerAncienMotPasse ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
              <mat-icon>{{ masquerAncienMotPasse ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Nouveau mot de passe *</label>
          <div class="password-input-wrapper">
            <input
              [type]="masquerNouveauMotPasse ? 'password' : 'text'"
              class="form-input password-input"
              formControlName="nouveauMotPasse"
              placeholder="••••••••">
            <button
              type="button"
              class="password-toggle-btn"
              (click)="masquerNouveauMotPasse = !masquerNouveauMotPasse"
              [attr.aria-label]="masquerNouveauMotPasse ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
              <mat-icon>{{ masquerNouveauMotPasse ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </div>
          <p style="font-size: 12px; color: var(--text-secondary); margin-top: 4px;">Minimum 6 caractères</p>
        </div>
        <div class="form-group">
          <label class="form-label">Confirmer le nouveau mot de passe *</label>
          <div class="password-input-wrapper">
            <input
              [type]="masquerConfirmationMotPasse ? 'password' : 'text'"
              class="form-input password-input"
              formControlName="confirmationMotPasse"
              placeholder="••••••••">
            <button
              type="button"
              class="password-toggle-btn"
              (click)="masquerConfirmationMotPasse = !masquerConfirmationMotPasse"
              [attr.aria-label]="masquerConfirmationMotPasse ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
              <mat-icon>{{ masquerConfirmationMotPasse ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </div>
          @if (motPasseForm.errors?.['motPasseNonIdentique'] && motPasseForm.get('confirmationMotPasse')?.touched) {
            <p style="font-size: 12px; color: var(--error); margin-top: 4px;">Les mots de passe ne correspondent pas</p>
          }
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="motPasseForm.invalid || chargement">
          @if (!chargement) {
            Modifier le mot de passe
          } @else {
            ⏳ Modification...
          }
        </button>
      </div>
    </form>
  }
</section>
